module.exports = __webpack_public_path__ + "61bca45f21aabc403940174093312c7a.png";